import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const mockExamManagementRoutes: RouteRecordRaw = {
  path: "/mockExamManagement",
  component: Layout,
  redirect: "/mockExamManagement/examProjectList",
  name: "MockExamManagement",
  meta: {
    title: "练习管理",
    icon: "homepage",
    permissionKey: "mockExamManagement",
  },
  children: [
    {
      path: "examProjectList",
      name: "MockExamProjectList",
      component: () =>
        import("@/views/Workbench/mock-exam-project/exam-project-list/index.vue"),
      meta: {
        title: "练习项目",
        icon: "homepage",
        permissionKey: "mockExamManagement:examProjectList",
      },
    },
    {
      path: "examAutoScoreList",
      name: "MockExamAutoScoreList",
      component: () =>
        import("@/views/Workbench/mock-exam-project/mock-exam-auto-score-list/index.vue"),
      meta: {
        title: "自动评分",
        icon: "homepage",
        permissionKey: "mockExamManagement:examAutoScoreList",
      },
    },
    {
      path: "mockExamStudentList",
      name: "MockExamStudentList",
      component: () =>
        import("@/views/Workbench/mock-exam-project/mock-exam-student-list/index.vue"),
      meta: {
        title: "考生列表",
        icon: "homepage",
        permissionKey: "mockExamManagement:mockExamStudentList",
      },
    },
    {
      path: "studentList",
      name: "MockExamManagementStudentList",
      component: () =>
        import("@/views/Workbench/mock-exam-project/mock-student-list.vue"),
      meta: {
        title: "学生列表",
        icon: "homepage",
        permissionKey: "mockExamManagement:examStudentTemplateList",
      },
    },
    {
      path: "studentScoreList",
      name: "MockExamManagementStudentScoreList",
      component: () =>
        import("@/views/Workbench/mock-exam-project/mock-exam-student-score-list/index.vue"),
      meta: {
        title: "考生成绩",
        icon: "homepage",
        permissionKey: "mockExamManagement:examStudentScoreList",
      },
    },
    {
      path: "examProjectReport",
      name: "MockExamProjectReport",
      component: () =>
        import("@/views/Workbench/mock-exam-project/exam-project-report/index.vue"),
      meta: {
        title: "项目报告",
        icon: "homepage",
        hidden: true,
        permissionKey: "statisticsManagement:examProjectReport",
      },
    },
  ],
};

export default mockExamManagementRoutes;
